import { MIME_TYPES } from '@shared/components';

export const AVERAGE_SCORE_TEMPLATES = ['average-score-by-part', 'average-score-by-subject'];
export const ACCEPT_ATTACH_DOCUMENT_FILE_TYPES = [MIME_TYPES.pdf] as string[];

export const CERTIFICATE_TEMPLATE_VARIANT_MAP = {
  AVERAGE_SCORE_BY_PART: 'average-score-by-part',
  AVERAGE_SCORE_BY_SUBJECT: 'average-score-by-subject',
  NO_SCORE: 'no-score',
  SECTION_SCORE: 'section-score',
} as const;

export const CERTIFICATE_TEMPLATE_MAP = {
  'average-score-by-part': 'AVERAGE_SCORE_BY_PART',
  'average-score-by-subject': 'AVERAGE_SCORE_BY_SUBJECT',
  'no-score': 'NO_SCORE',
  'section-score': 'SECTION_SCORE',
} as const;

export const CERTIFICATE_TEMPLATE_NAME_MAP = {
  'average-score-by-part': 'Average Score (รายหมวด)',
  'average-score-by-subject': 'Average Score (รายวิชา)',
  'no-score': 'No Score',
  'section-score': 'Section Score',
} as const;

export const AVERAGE_SCORE_CONDITION_MAP = {
  ALL_CENTERS: 'all-centers',
  EACH_CENTER: 'each-center',
} as const;

export const EXAM_DURATION_TYPE_MAP = {
  SINGLE: 'single-session',
  MULTIPLE: 'multiple-session',
} as const;

export const QUESTIONNAIRE_TEMPLATE_MAP = {
  TEMPLATE_A: 'template-a',
  TEMPLATE_B: 'template-b',
  TEMPLATE_C: 'template-c',
} as const;

export const QUESTIONNAIRE_TEMPLATE_OPTIONS = [
  { value: 'template-a', label: 'Standard' },
  { value: 'template-b', label: 'Long Form' },
  { value: 'template-c', label: 'Short Form' },
] as const satisfies { value: string; label: string }[];
